
import { userConstants } from '../_constants';
import { empresaConstants } from '../_constants/empresa.constants';


export function empresa(state = {}, action) {
  switch (action.type) { 
    case empresaConstants.TRAER_EMPRESAS:
      return { 
        ...state,
        empresas: action.data.empresas
      };           
        
        case empresaConstants.AGREGAR_EMPRESA:
          return { 
            ...state,
            empresas: state.empresas?state.empresas.concat(action.data.tutorial):[action.data.tutorial]  
          }; 

          case empresaConstants.ACT_EMPRESA:
          return { 
            ...state,
            empresas: state.empresas.map(tuto => {                          
              if (tuto.id === action.data.empresa.id) {             
                return action.data.empresa;
              }else return tuto; 
            })
          }; 

        case userConstants.LOGOUT:
          return {};    
        
    default:
      return state
  }
}